import { ApiClient } from '../shared/api/api-client'
import { CompanySettingsModel, Currency, UpdateEInvoiceConfigurationResult } from '../shared/models'

export class CompanySettingsApi {
    static get(config?: { ignoreLoader?: boolean }) {
        // The API wrapper forwards GET's second argument as Axios request config.
        return ApiClient.get<CompanySettingsModel>(`api/CompanySettings`, config)
    }

    static getDefaultCurrency() {
        return ApiClient.get<Currency>(`api/CompanySettings/GetDefaultCurrency`)
    }

    static getSimpleCompanySettings() {
        return ApiClient.get<{ vat: number; showProductDimensionsInfo: boolean; canEditPurchasePrice: boolean; isAccountingVat: boolean }>(
            `api/CompanySettings/GetSimpleCompanySettings`
        )
    }

    static getReceiptListSettings() {
        return ApiClient.get<{
            defaultMailText: string
            isFiscalizationActive: boolean
            isEInvoiceConfigured: boolean
        }>(`api/CompanySettings/ReceiptListSettings`)
    }

    static getPackageSettings() {
        return ApiClient.get<{ canCreateUsers: boolean; canCreateSalePlaces: boolean; canChangeSalePlaces: boolean }>(
            `api/CompanySettings/PackageSettings`
        )
    }

    static getTenderListSettings() {
        return ApiClient.get<{ defaultMailText: string }>(`api/CompanySettings/TenderListSettings`)
    }

    static update(settings: CompanySettingsModel, config?: { ignoreLoader?: boolean }) {
        return ApiClient.post<boolean>(`api/CompanySettings`, settings, {}, config)
    }

    static linkDocumentHeaderResource(linkRequest: { resourceId: number | null }) {
        return ApiClient.post<CompanySettingsModel>(`api/Company/LinkDocumentHeaderResource`, linkRequest)
    }

    static linkDocumentFooterResource(linkRequest: { resourceId: number | null }) {
        return ApiClient.post<CompanySettingsModel>(`api/Company/LinkDocumentFooterResource`, linkRequest)
    }

    static LinkDocumentSignatureResource(linkRequest: { resourceId: number | null }) {
        return ApiClient.post<CompanySettingsModel>(`api/Company/LinkDocumentSignatureResource`, linkRequest)
    }

    static GetEInvoiceConfiguration() {
        return ApiClient.get<{
            eReceiptUserName: string
            legalCompanyName: string
            eReceiptType?: number
            defaultClassificationCode?: string | null
        }>(`api/CompanySettings/GetEInvoiceConfiguration`)
    }

    static SaveEInvoiceConfiguration(model: {
        eReceiptUserName: string
        legalCompanyName: string
        eReceiptPassword: string
        secondBankAccount?: string
        eReceiptType?: number
    }) {
        return ApiClient.post<UpdateEInvoiceConfigurationResult>(`api/CompanySettings/SaveEInvoiceConfiguration`, model)
    }
}
